import { render } from "./CalendarDialogue.vue?vue&type=template&id=2b6a8aa2&scoped=true"
import script from "./CalendarDialogue.vue?vue&type=script&lang=js"
export * from "./CalendarDialogue.vue?vue&type=script&lang=js"

import "./CalendarDialogue.vue?vue&type=style&index=0&id=2b6a8aa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6a8aa2"]])

export default __exports__